import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { infoButton_template }  from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;
enum Recategorization {
    CATEGORY = 'category',
    TAG = 'tag',
}

export class recategorizationList_template extends vnTemplate {

    //As VM
    protected filterCurrentTag: filterSimple_template;
    protected filterTargetTag: filterSimple_template;
    protected filterCurrentCategory: filterSimple_template;
    protected filterTargetCategory: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected resultInfosCurrentTags: resultsInfo_template;
    protected resultInfosTargetTags: resultsInfo_template;
    protected resultInfosCurrentCategories: resultsInfo_template;
    protected resultInfosTargetCategories: resultsInfo_template;
    protected pagination: pagination_template;
    protected paginationCurrentTags: pagination_template;
    protected paginationTargetTags: pagination_template;
    protected paginationCurrentCategories: pagination_template;
    protected paginationTargetCategories: pagination_template;
    protected recategorizationTooltip: infoButton_template;
    protected recategorizationTooltipContent;
    protected statusTooltip: infoButton_template;
    protected statusTooltipContent;

    protected initPartial() {
        this.filterCurrentTag = new filterSimple_template("filterCurrentTag", this.getTemplateViewModel(), this.caller);
        this.filterTargetTag = new filterSimple_template("filterTargetTag", this.getTemplateViewModel(), this.caller);
        this.filterCurrentCategory = new filterSimple_template("filterCurrentCategory", this.getTemplateViewModel(), this.caller);
        this.filterTargetCategory = new filterSimple_template("filterTargetCategory", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.resultInfosCurrentTags = new resultsInfo_template('resultInfoCurrentTags', this.getTemplateViewModel(), this.caller);
        this.resultInfosTargetTags = new resultsInfo_template('resultInfoTargetTags', this.getTemplateViewModel(), this.caller);
        this.resultInfosCurrentCategories = new resultsInfo_template('resultInfoCurrentCategories', this.getTemplateViewModel(), this.caller);
        this.resultInfosTargetCategories = new resultsInfo_template('resultInfoTargetCategories', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.paginationCurrentTags = new pagination_template("paginationCurrentTags", this.getTemplateViewModel(), this.caller);
        this.paginationCurrentTags.getTemplateViewModel().itemPerPage = 10;
        this.paginationCurrentTags.getTemplateViewModel().reducedSidePages = true;
        this.paginationTargetTags = new pagination_template("paginationTargetTags", this.getTemplateViewModel(), this.caller);
        this.paginationTargetTags.getTemplateViewModel().itemPerPage = 10;
        this.paginationTargetTags.getTemplateViewModel().reducedSidePages = true;
        this.paginationCurrentCategories = new pagination_template("paginationCurrentCategories", this.getTemplateViewModel(), this.caller);
        this.paginationCurrentCategories.getTemplateViewModel().itemPerPage = 10;
        this.paginationCurrentCategories.getTemplateViewModel().reducedSidePages = true;
        this.paginationTargetCategories = new pagination_template("paginationTargetCategories", this.getTemplateViewModel(), this.caller);
        this.paginationTargetCategories.getTemplateViewModel().itemPerPage = 10;
        this.paginationTargetCategories.getTemplateViewModel().reducedSidePages = true;

        this.recategorizationTooltipContent = `
            <p>This tool is intended for scenarios where a tag or category should be replaced everywhere it is used by another tag or category.</p>
            <p>On articles, the tool will:</p>
            <p>- Replace the current tag/category with the target tag/category.</p>
            <p>On tags/categories, the tool will:</p>
            <p>- Make the current tag/category unavailable for use.</p>
            <p>- Make the target tag/category available for use.</p>
            <p>On listing pages, the tool will:</p>
            <p>- Replace the current tag/category with the target tag/category.</p>
            <p>- Summarize the listing pages that will be deleted to prevent the duplication of data.</p>
        `;
        this.recategorizationTooltip = new infoButton_template('recategorizationTooltip', this.getTemplateViewModel(), this.caller);
        this.recategorizationTooltip.setTitle('RECATEGORIZATION TOOL');
        this.recategorizationTooltip.setContent(this.recategorizationTooltipContent);

        this.statusTooltipContent = `
            <p>This status indicates the progression of updates to the affected data. 
            It excludes the sync status of the data to the website, which will be queued separately after the request is completed. 
            Only “Pending” requests can be deleted.</p>
        `;
        this.statusTooltip = new infoButton_template('statusTooltip', this.getTemplateViewModel(), this.caller);
        this.statusTooltip.setTitle('STATUS');
        this.statusTooltip.setContent(this.statusTooltipContent);
    }

    public getViewModelForRequest(): any {
        return {
            currentTagOrderBy: this.getTemplateViewModel().currentTagOrderBy,
            currentTagOrderByDirection: this.getTemplateViewModel().currentTagOrderByDirection,
            currentTagOrderByAndDirection: this.getTemplateViewModel().currentTagOrderByAndDirection,
            targetTagOrderBy: this.getTemplateViewModel().targetTagOrderBy,
            targetTagOrderByDirection: this.getTemplateViewModel().targetTagOrderByDirection,
            targetTagOrderByAndDirection: this.getTemplateViewModel().targetTagOrderByAndDirection,
            currentCategoryOrderBy: this.getTemplateViewModel().currentCategoryOrderBy,
            currentCategoryOrderByDirection: this.getTemplateViewModel().currentCategoryOrderByDirection,
            currentCategoryOrderByAndDirection: this.getTemplateViewModel().currentCategoryOrderByAndDirection,
            targetCategoryOrderBy: this.getTemplateViewModel().targetCategoryOrderBy,
            targetCategoryOrderByDirection: this.getTemplateViewModel().targetCategoryOrderByDirection,
            targetCategoryOrderByAndDirection: this.getTemplateViewModel().targetCategoryOrderByAndDirection,
            recategorizationOrderBy: this.getTemplateViewModel().recategorizationOrderBy,
            recategorizationOrderByDirection: this.getTemplateViewModel().recategorizationOrderByDirection,
            recategorizationOrderByAndDirection: this.getTemplateViewModel().recategorizationOrderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            paginationCurrentTags: this.getTemplateViewModel().paginationCurrentTags,
            paginationTargetTags: this.getTemplateViewModel().paginationTargetTags,
            paginationCurrentCategories: this.getTemplateViewModel().paginationCurrentCategories,
            paginationTargetCategories: this.getTemplateViewModel().paginationTargetCategories,
            filterCurrentTags : {
                keywords : this.getTemplateViewModel().filterCurrentTag.filterKeyword
            },
            filterTargetTags : {
                keywords : this.getTemplateViewModel().filterTargetTag.filterKeyword
            },
            filterCurrentCategories : {
                keywords : this.getTemplateViewModel().filterCurrentCategory.filterKeyword
            },
            filterTargetCategories : {
                keywords : this.getTemplateViewModel().filterTargetCategory.filterKeyword
            },
        }
    }

    protected buildViewModel(): any {
        let self = this
        return {
            recategorizations: ko.observableArray([]),
            currentTagOrderBy: ko.observable("name"),
            currentTagOrderByDirection: ko.observable("ASC"),
            currentTagOrderByAndDirection: ko.observable("name_ASC"),
            targetTagOrderBy: ko.observable("name"),
            targetTagOrderByDirection: ko.observable("ASC"),
            targetTagOrderByAndDirection: ko.observable("name_ASC"),
            currentCategoryOrderBy: ko.observable("name"),
            currentCategoryOrderByDirection: ko.observable("ASC"),
            currentCategoryOrderByAndDirection: ko.observable("name_ASC"),
            targetCategoryOrderBy: ko.observable("name"),
            targetCategoryOrderByDirection: ko.observable("ASC"),
            targetCategoryOrderByAndDirection: ko.observable("name_ASC"),
            recategorizationOrderBy: ko.observable("dateCreation"),
            recategorizationOrderByDirection: ko.observable("DESC"),
            recategorizationOrderByAndDirection: ko.observable("dateCreation_DESC"),
            idRecategorizationToDelete: ko.observable(null),
            currentTags: ko.observableArray([]),
            targetTags: ko.observableArray([]),
            currentCategories: ko.observableArray([]),
            targetCategories: ko.observableArray([]),
            selectedTab: ko.observable(Recategorization.TAG),
            idCurrentCategory: ko.observable(null),
            idTargetCategory: ko.observable(null),
            idCurrentTag: ko.observable(null),
            idTargetTag: ko.observable(null),
            currentName: ko.observable(null),
            targetName: ko.observable(null),
            affectedArticles: ko.observable(null),
            affectedListingPages: ko.observable(null),
            affectedDeletedListingPage: ko.observable(null),
            affectedConflictedListingPage: ko.observable(null),
            isCurrentTagsLoading: ko.observable(0),
            isTargetTagsLoading: ko.observable(0),
            isCurrentCategoriesLoading: ko.observable(0),
            isTargetCategoriesLoading: ko.observable(0),
            isRecategorizationLoading: ko.observable(0),
            onClickCurrentTagReorder: (value, data, event) => {
                self.onClickCurrentTagReorder(value, data, event);
            },
            onClickTargetTagReorder: (value, data, event) => {
                self.onClickTargetTagReorder(value, data, event);
            },
            onClickCurrentCategoryReorder: (value, data, event) => {
                self.onClickCurrentCategoryReorder(value, data, event);
            },
            onClickTargetCategoryReorder: (value, data, event) => {
                self.onClickTargetCategoryReorder(value, data, event);
            },
            onClickRecategorizationReorder: (value, data, event) => {
                self.onClickRecategorizationReorder(value, data, event);
            },
            onClickDelete: (data, event)=> {
                self.onClickDelete()
            },
            onClickHideDelete: (data, event)=> {
                self.onClickHideDelete()
            },
            onClickShowDelete: (data, event)=> {
                self.onClickShowDelete(data)
            },
            onClickTab: function (value, data, event) {
                self.onClickTab(value);
            },
            onClickMerge: function (data, event) {
                self.onClickMerge()
            },
            onClickHidePreview: (data, event)=> {
                self.onClickHidePreview()
            },
            onClickShowPreview: (data, event)=> {
                self.onClickShowPreview()
            },
            onClickConfirm: (data, event)=> {
                self.onClickConfirm()
            },
        }
    }

    protected getTemplateHtml(): string {
        return (`
        
        <div class="w-list-results" id="categorize-tool">
            <div class="w-form">
                <div class="form-header">
                    <h3 class="form-title icon i-recat-tool">Recategorize Tool
                        <div class="w-tooltips-adv pos-bottom short">
                            ` + this.recategorizationTooltip.getHtmlBuild() + `
                        </div>
                    </h3>
                </div>
                <div class="form-pagination">
                    <button class="btn icon i-tag" type="button" data-bind="event: { click: onClickTab.bind($data,'tag') }, css: { 'is-activated' : selectedTab() == 'tag'}"><span class="btn-text">Tag Recategorization</span></button>                         
                    <button class="btn icon i-category" type="button" data-bind="event: { click: onClickTab.bind($data,'category') }, css: { 'is-activated' : selectedTab() == 'category'}"><span class="btn-text">Category Recategorization</span></button>
                </div>
            
                <div class="w-tabs-content" data-bind="visible: selectedTab() == 'tag'">
                    <div class="w-form">
                        <div class="list-header w-justify">
                            <div class="w-left" >
                                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filterCurrentTag }">
                                    <div class="w-search-feild icon i-search2">
                                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                                        <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="w-right">
                                ` + this.paginationCurrentTags.getHtmlBuild() + `
                            </div>
                        </div>
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>Source Tags</span></th>                        
                                </tr>
                            </thead>                            
                        </table>
                        <table class="list-results" data-bind="css: { loading: isCurrentTagsLoading }">
                            ` + this.resultInfosCurrentTags.getHtmlBuild() + `
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentTagReorder.bind($data, 'id') }, css: { 'list-sort-desc': currentTagOrderByAndDirection()=='id_DESC', 'list-sort-asc': currentTagOrderByAndDirection()=='id_ASC' }">ID</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentTagReorder.bind($data, 'name') }, css: { 'list-sort-desc': currentTagOrderByAndDirection()=='name_DESC', 'list-sort-asc': currentTagOrderByAndDirection()=='name_ASC' }">Name</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentTagReorder.bind($data, 'tagType') }, css: { 'list-sort-desc': currentTagOrderByAndDirection()=='tagType_DESC', 'list-sort-asc': currentTagOrderByAndDirection()=='tagType_ASC' }">Tag Type</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentTagReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': currentTagOrderByAndDirection()=='articleCount_DESC', 'list-sort-asc': currentTagOrderByAndDirection()=='articleCount_ASC' }">Article Count</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentTagReorder.bind($data, 'isSelectable') }, css: { 'list-sort-desc': currentTagOrderByAndDirection()=='isSelectable_DESC', 'list-sort-asc': currentTagOrderByAndDirection()=='isSelectable_ASC' }" class="icon i-dropdown-simple">Available for Use</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: currentTags">
                                <tr>
                                    <td>
                                        <span data-bind="visible: isLogged" class="form-title icon i-status"></span>
                                    </td>
                                    <td>
                                        <input type="radio" name="radio-group-1" data-bind="checked: $parent.idCurrentTag, value: id, attr: {id: 'current_tag_' + $data.id}">
                                        <label data-bind="attr: {for: 'current_tag_' + $data.id}"></label>
                                    </td>
                                    <td><span data-bind="text: id"></span></td>
                                    <td><span data-bind="text: name"></span></td>
                                    <td><span data-bind="text: type"></span></td>
                                    <td><span data-bind="text: articleCount"></span></td>
                                    <td><span data-bind="text: isSelectable"></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>  
                    <div class="w-form">  
                        <div class="list-header w-justify">
                            <div class="w-left" >
                                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filterTargetTag }">
                                    <div class="w-search-feild icon i-search2">
                                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                                        <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="w-right">
                                ` + this.paginationTargetTags.getHtmlBuild() + `
                            </div>
                        </div>    
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>Target Tag</span></th>                        
                                </tr>
                            </thead>                            
                        </table>                        
                        <table class="list-results" data-bind="css: { loading: isTargetTagsLoading }">
                            ` + this.resultInfosTargetTags.getHtmlBuild() + `
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetTagReorder.bind($data, 'id') }, css: { 'list-sort-desc': targetTagOrderByAndDirection()=='id_DESC', 'list-sort-asc': targetTagOrderByAndDirection()=='id_ASC' }">ID</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetTagReorder.bind($data, 'name') }, css: { 'list-sort-desc': targetTagOrderByAndDirection()=='name_DESC', 'list-sort-asc': targetTagOrderByAndDirection()=='name_ASC' }">Name</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetTagReorder.bind($data, 'tagType') }, css: { 'list-sort-desc': targetTagOrderByAndDirection()=='tagType_DESC', 'list-sort-asc': targetTagOrderByAndDirection()=='tagType_ASC' }">Tag Type</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetTagReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': targetTagOrderByAndDirection()=='articleCount_DESC', 'list-sort-asc': targetTagOrderByAndDirection()=='articleCount_ASC' }">Article Count</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetTagReorder.bind($data, 'isSelectable') }, css: { 'list-sort-desc': targetTagOrderByAndDirection()=='isSelectable_DESC', 'list-sort-asc': targetTagOrderByAndDirection()=='isSelectable_ASC' }" class="icon i-dropdown-simple">Available for Use</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: targetTags">
                                <tr>
                                    <td>
                                        <span data-bind="visible: isLogged" class="form-title icon i-status"></span>
                                    </td>
                                    <td>                                        
                                        <input type="radio" name="radio-group-2" data-bind="checked: $parent.idTargetTag, value: id, attr: {id: 'target_tag_' + $data.id}">
                                        <label data-bind="attr: {for: 'target_tag_' + $data.id}"></label>
                                    </td>
                                    <td><span data-bind="text: id"></span></td>
                                    <td><span data-bind="text: name"></span></td>
                                    <td><span data-bind="text: type"></span></td>
                                    <td><span data-bind="text: articleCount"></span></td>
                                    <td><span data-bind="text: isSelectable"></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>    
                </div>
        
                <div class="w-tabs-content" data-bind="visible: selectedTab() == 'category'">
                    <div class="w-form">
                        <div class="list-header w-justify">
                            <div class="w-left" >
                                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filterCurrentCategory }">
                                    <div class="w-search-feild icon i-search2">
                                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                                        <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="w-right">
                                ` + this.paginationCurrentCategories.getHtmlBuild() + `
                            </div>
                        </div>
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>Source Categories</span></th>                        
                                </tr>
                            </thead>                            
                        </table>                        
                        <table class="list-results" data-bind="css: { loading: isCurrentCategoriesLoading }">
                            ` + this.resultInfosCurrentCategories.getHtmlBuild() + `
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentCategoryReorder.bind($data, 'id') }, css: { 'list-sort-desc': currentCategoryOrderByAndDirection()=='id_DESC', 'list-sort-asc': currentCategoryOrderByAndDirection()=='id_ASC' }">ID</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentCategoryReorder.bind($data, 'name') }, css: { 'list-sort-desc': currentCategoryOrderByAndDirection()=='name_DESC', 'list-sort-asc': currentCategoryOrderByAndDirection()=='name_ASC' }">Name</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentCategoryReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': currentCategoryOrderByAndDirection()=='articleCount_DESC', 'list-sort-asc': currentCategoryOrderByAndDirection()=='articleCount_ASC' }">Article Count</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickCurrentCategoryReorder.bind($data, 'isSelectable') }, css: { 'list-sort-desc': currentCategoryOrderByAndDirection()=='isSelectable_DESC', 'list-sort-asc': currentCategoryOrderByAndDirection()=='isSelectable_ASC' }" class="icon i-dropdown-simple">Available for Use</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: currentCategories">
                                <tr>
                                    <td>
                                        <span data-bind="visible: isLogged" class="form-title icon i-status"></span>
                                    </td>
                                    <td>                                        
                                        <input type="radio" name="radio-group-3" data-bind="checked: $parent.idCurrentCategory, value: id, attr: {id: 'current_category_' + $data.id}">
                                        <label data-bind="attr: {for: 'current_category_' + $data.id}"></label>
                                    </td>
                                    <td><span data-bind="text: id"></span></td>
                                    <td><span data-bind="text: name"></span></td>
                                    <td><span data-bind="text: articleCount"></span></td>
                                    <td><span data-bind="text: isSelectable"></span></td>
                                </tr>
                            </tbody>
                        </table>
                </div>
                <div class="w-form">                        
                        <div class="list-header w-justify">
                            <div class="w-left" >
                                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filterTargetCategory }">
                                    <div class="w-search-feild icon i-search2">
                                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                                        <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="w-right">
                                ` + this.paginationTargetCategories.getHtmlBuild() + `
                            </div>
                        </div>   
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>Target Category</span></th>                        
                                </tr>
                            </thead>                            
                        </table>                          
                        <table class="list-results" data-bind="css: { loading: isTargetCategoriesLoading }">
                            ` + this.resultInfosTargetCategories.getHtmlBuild() + `
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>                                    
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetCategoryReorder.bind($data, 'id') }, css: { 'list-sort-desc': targetCategoryOrderByAndDirection()=='id_DESC', 'list-sort-asc': targetCategoryOrderByAndDirection()=='id_ASC' }">ID</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetCategoryReorder.bind($data, 'name') }, css: { 'list-sort-desc': targetCategoryOrderByAndDirection()=='name_DESC', 'list-sort-asc': targetCategoryOrderByAndDirection()=='name_ASC' }">Name</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetCategoryReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': targetCategoryOrderByAndDirection()=='articleCount_DESC', 'list-sort-asc': targetCategoryOrderByAndDirection()=='articleCount_ASC' }">Article Count</span></th>
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickTargetCategoryReorder.bind($data, 'isSelectable') }, css: { 'list-sort-desc': targetCategoryOrderByAndDirection()=='isSelectable_DESC', 'list-sort-asc': targetCategoryOrderByAndDirection()=='isSelectable_ASC' }" class="icon i-dropdown-simple">Available for Use</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: targetCategories">
                                <tr>
                                    <td>
                                        <span data-bind="visible: isLogged" class="form-title icon i-status"></span>
                                    </td>
                                    <td>                                        
                                        <input type="radio" name="radio-group-4" data-bind="checked: $parent.idTargetCategory, value: id, attr: {id: 'target_category_' + $data.id}">
                                        <label data-bind="attr: {for: 'target_category_' + $data.id}"></label>
                                    </td>
                                    <td><span data-bind="text: id"></span></td>
                                    <td><span data-bind="text: name"></span></td>
                                    <td><span data-bind="text: articleCount"></span></td>
                                    <td><span data-bind="text: isSelectable"></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="form-footer">                
                    <button data-bind="event: { click: onClickMerge }, css: { 'is-disable': (!idCurrentTag() || !idTargetTag()) && (!idCurrentCategory() || !idTargetCategory()) }" class="btn highlight" type="button">Merge</button>
                </div>                
            </div>
            
            <div class="w-form">
                <div class="form-header">
                    <h3 class="form-title icon i-status">Log</h3>
                </div>
                <div class="list-header w-justify">
                    <div class="w-right">
                        ` + this.pagination.getHtmlBuild() + `
                    </div>
                </div>    
                <table class="list-results" data-bind="css: { loading: isRecategorizationLoading }">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickRecategorizationReorder.bind($data, 'type') }, css: { 'list-sort-desc': recategorizationOrderByAndDirection()=='type_DESC', 'list-sort-asc': recategorizationOrderByAndDirection()=='type_ASC' }">Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickRecategorizationReorder.bind($data, 'sourceID') }, css: { 'list-sort-desc': recategorizationOrderByAndDirection()=='sourceID_DESC', 'list-sort-asc': recategorizationOrderByAndDirection()=='sourceID_ASC' }">Source ID</span></th>
                            <th><span>Source</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickRecategorizationReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': recategorizationOrderByAndDirection()=='articleCount_DESC', 'list-sort-asc': recategorizationOrderByAndDirection()=='articleCount_ASC' }">Article Count</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickRecategorizationReorder.bind($data, 'listingPageCount') }, css: { 'list-sort-desc': recategorizationOrderByAndDirection()=='listingPageCount_DESC', 'list-sort-asc': recategorizationOrderByAndDirection()=='listingPageCount_ASC' }">Listing Page Count</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickRecategorizationReorder.bind($data, 'targetID') }, css: { 'list-sort-desc': recategorizationOrderByAndDirection()=='targetID_DESC', 'list-sort-asc': recategorizationOrderByAndDirection()=='targetID_ASC' }">Target ID</span></th>
                            <th><span>Target</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickRecategorizationReorder.bind($data, 'dateCreation') }, css: { 'list-sort-desc': recategorizationOrderByAndDirection()=='dateCreation_DESC', 'list-sort-asc': recategorizationOrderByAndDirection()=='dateCreation_ASC' }">Date Requested</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickRecategorizationReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': recategorizationOrderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': recategorizationOrderByAndDirection()=='dateUpdated_ASC' }">Date Completed</span></th>
                            <th>
                                <div class="w-justify">                               
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickRecategorizationReorder.bind($data, 'status') }, css: { 'list-sort-desc': recategorizationOrderByAndDirection()=='status_DESC', 'list-sort-asc': recategorizationOrderByAndDirection()=='status_ASC' }">Status
                                    </span>
                                    <div class="w-tooltips-adv pos-left short">
                                            ` + this.statusTooltip.getHtmlBuild() + `
                                    </div>
                                </div>    
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: recategorizations">
                        <tr>
                            <td><span data-bind="text: type"></span></td>  
                            <td><span data-bind="text: sourceID"></span></td>
                            <td><span data-bind="text: source"></span> <span data-bind="text: sourceType"></span></td>     
                            <td><span data-bind="text: articleCount"></span></td>
                            <td><span data-bind="text: listingPageCount"></span></td>
                            <td><span data-bind="text: targetID"></span></td>
                            <td><span data-bind="text: target"></span> <span data-bind="text: targetType"></span></td>
                            <td><span data-bind="text: dateRequested"></span></td>
                            <td><span data-bind="text: dateCompleted"></span></td>    
                            <td><span data-bind="class: statusClass, text: status"></span></td>    
                            <td><span data-bind="visible: status == 'Pending'"><button style="margin-left: 0.5rem" type="button" data-bind="event: { click: $parent.onClickShowDelete }, clickBubble: false" class="btn border only-icon highlight icon i-delete"></button></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>

        <div id="delete-dialog" class="w-lightbox light-theme">
            <div class="lightbox-content">
                <div class="w-form lightbox-form">
                    <div class="form-header">
                        <h3 class="form-title">Deleting recategorization task</h3>
                        <button type="button"  data-bind="event: { click: onClickHideDelete }" class="close-button icon i-close-2"></button>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <p class="form-text">This action is irreversible</p>
                            <p class="form-text">Are you sure you want to delete this recategorization task?</p>
                        </div>
                     </div>
                    <div class="form-footer">
                        <button type="button" data-bind="event: { click: onClickHideDelete }" class="btn">Cancel</button>
                        <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="preview-dialog" class="w-lightbox light-theme">
            <div class="lightbox-content">
                <div class="w-form lightbox-form">
                    <div class="form-header">
                        <h3 class="form-title">Confirm recategorization task</h3>
                        <button type="button"  data-bind="event: { click: onClickHidePreview }" class="close-button icon i-close-2"></button>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <p>Data for the following will be impacted:</p>
                            <p>- <span data-bind="text: affectedArticles"></span> article(s).</p>
                            <p data-bind="visible: (idCurrentTag() && idTargetTag())">- Tag <span data-bind="text: currentName"></span> (ID :<span data-bind="text: idCurrentTag"></span>) will be made unavailable for use if not already.</p>
                            <p data-bind="visible: (idCurrentTag() && idTargetTag())">- Tag <span data-bind="text: targetName"></span> (ID :<span data-bind="text: idTargetTag"></span>) will be made available for use if not already.</p>
                            <p data-bind="visible: (idCurrentCategory() && idTargetCategory())">- Category <span data-bind="text: currentName"></span> (ID :<span data-bind="text: idCurrentCategory"></span>) will be made unavailable for use if not already.</p>
                            <p data-bind="visible: (idCurrentCategory() && idTargetCategory())">- Category <span data-bind="text: targetName"></span> (ID :<span data-bind="text: idTargetCategory"></span>) will be made available for use if not already.</p>
                            <p>- <span data-bind="text: affectedListingPages"></span> listing page(s).</p>
                            <p data-bind="visible: (affectedDeletedListingPage())">- Listing Page <span data-bind="text: affectedDeletedListingPage"></span> will be deleted due to duplication with the <span data-bind="text: affectedConflictedListingPage"></span> listing page.</p>
                        </div>
                     </div>
                    <div class="form-footer">
                        <button type="button" data-bind="event: { click: onClickHidePreview }" class="btn">Cancel</button>
                        <button type="button" data-bind="event: { click: onClickConfirm }" class="btn highlight">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
        `);
    }

    protected getTemplateName(): string {
        return "recategorizationList_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setResultInfoCurrentTags(nbResults, nbPages, execTime) {

        this.resultInfosCurrentTags.setExecutionTime(execTime);
        this.resultInfosCurrentTags.setNbResults(nbResults);
        this.resultInfosCurrentTags.setNbPages(nbPages);
    }

    public setResultInfoTargetTags(nbResults, nbPages, execTime) {

        this.resultInfosTargetTags.setExecutionTime(execTime);
        this.resultInfosTargetTags.setNbResults(nbResults);
        this.resultInfosTargetTags.setNbPages(nbPages);
    }

    public setResultInfoCurrentCategories(nbResults, nbPages, execTime) {

        this.resultInfosCurrentCategories.setExecutionTime(execTime);
        this.resultInfosCurrentCategories.setNbResults(nbResults);
        this.resultInfosCurrentCategories.setNbPages(nbPages);
    }

    public setResultInfoTargetCategories(nbResults, nbPages, execTime) {

        this.resultInfosTargetCategories.setExecutionTime(execTime);
        this.resultInfosTargetCategories.setNbResults(nbResults);
        this.resultInfosTargetCategories.setNbPages(nbPages);
    }

    protected onClickCurrentTagReorder(value, data, event): any {

        data.currentTagOrderBy(value);
        if (data.currentTagOrderByAndDirection().includes(value)) {
            if (data.currentTagOrderByDirection() == "DESC") {
                data.currentTagOrderByDirection("ASC");
            } else {
                data.currentTagOrderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.currentTagOrderByDirection("DESC");
        }

        data.currentTagOrderByAndDirection(value + "_" + data.currentTagOrderByDirection());

        this.caller.recategorizationsListReorder(1);
    }

    protected onClickTargetTagReorder(value, data, event): any {

        data.targetTagOrderBy(value);
        if (data.targetTagOrderByAndDirection().includes(value)) {
            if (data.targetTagOrderByDirection() == "DESC") {
                data.targetTagOrderByDirection("ASC");
            } else {
                data.targetTagOrderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.targetTagOrderByDirection("DESC");
        }

        data.targetTagOrderByAndDirection(value + "_" + data.targetTagOrderByDirection());

        this.caller.recategorizationsListReorder(2);
    }

    protected onClickCurrentCategoryReorder(value, data, event): any {

        data.currentCategoryOrderBy(value);
        if (data.currentCategoryOrderByAndDirection().includes(value)) {
            if (data.currentCategoryOrderByDirection() == "DESC") {
                data.currentCategoryOrderByDirection("ASC");
            } else {
                data.currentCategoryOrderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.currentCategoryOrderByDirection("DESC");
        }

        data.currentCategoryOrderByAndDirection(value + "_" + data.currentCategoryOrderByDirection());

        this.caller.recategorizationsListReorder(3);
    }

    protected onClickTargetCategoryReorder(value, data, event): any {

        data.targetCategoryOrderBy(value);
        if (data.targetCategoryOrderByAndDirection().includes(value)) {
            if (data.targetCategoryOrderByDirection() == "DESC") {
                data.targetCategoryOrderByDirection("ASC");
            } else {
                data.targetCategoryOrderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.targetCategoryOrderByDirection("DESC");
        }

        data.targetCategoryOrderByAndDirection(value + "_" + data.targetCategoryOrderByDirection());

        this.caller.recategorizationsListReorder(4);
    }

    protected onClickRecategorizationReorder(value, data, event): any {

        data.recategorizationOrderBy(value);
        if (data.recategorizationOrderByAndDirection().includes(value)) {
            if (data.recategorizationOrderByDirection() == "DESC") {
                data.recategorizationOrderByDirection("ASC");
            } else {
                data.recategorizationOrderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.recategorizationOrderByDirection("DESC");
        }

        data.recategorizationOrderByAndDirection(value + "_" + data.recategorizationOrderByDirection());

        this.caller.recategorizationsListReorder(5);
    }

    onClickDelete() {
        let recategorization_id = this.getTemplateViewModel().idRecategorizationToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteRecategorization(recategorization_id);
    }

    onClickConfirm(): any {
        this.togglePreviewDialogVisibility();
        this.caller.confirmRecategorization();
    }

    onClickMerge(): any {
        let idOld;
        let idNew;
        let listOld;
        let listNew;

        if(this.getTemplateViewModel().idCurrentCategory() == null) {
            idOld = this.getTemplateViewModel().idCurrentTag();
            idNew = this.getTemplateViewModel().idTargetTag();
            listOld = this.getTemplateViewModel().currentTags();
            listNew = this.getTemplateViewModel().targetTags();
        }
        else if(this.getTemplateViewModel().idCurrentTag() == null) {
            idOld = this.getTemplateViewModel().idCurrentCategory();
            idNew = this.getTemplateViewModel().idTargetCategory();
            listOld = this.getTemplateViewModel().currentCategories();
            listNew = this.getTemplateViewModel().targetCategories();
        }

        let currentName = listOld.find(item => item.id === idOld).name;
        let targetName = listNew.find(item => item.id === idNew).name;

        this.getTemplateViewModel().currentName(currentName);
        this.getTemplateViewModel().targetName(targetName);
        this.onClickShowPreview();
    }
    onClickHideDelete(): any {
        this.getTemplateViewModel().idRecategorizationToDelete(null);
        this.toggleDeleteDialogVisibility();
    }
    onClickShowDelete(data): any {
        this.getTemplateViewModel().idRecategorizationToDelete(data);
        this.toggleDeleteDialogVisibility();
    }
    onClickHidePreview(): any {
        this.togglePreviewDialogVisibility();
    }
    onClickShowPreview(): any {
        this.caller.getRecategorizationPreview();
        this.togglePreviewDialogVisibility();
    }

    protected onClickTab(tab) {
        this.clearSelections();
        this.getTemplateViewModel().selectedTab(tab);
    }

    protected clearSelections() {
        this.getTemplateViewModel().idCurrentTag(null);
        this.getTemplateViewModel().idTargetTag(null);
        this.getTemplateViewModel().idCurrentCategory(null);
        this.getTemplateViewModel().idTargetCategory(null);
    }

    public toggleDeleteDialogVisibility() {
        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    public togglePreviewDialogVisibility() {
        document.getElementById('preview-dialog').classList.toggle('is-visible');
    }

    public setCurrentTags(currentTags) {
        this.getTemplateViewModel().currentTags(currentTags);
    }

    public setTargetTags(targetTags) {
        this.getTemplateViewModel().targetTags(targetTags);
    }

    public setCurrentCategories(currentCategories) {
        this.getTemplateViewModel().currentCategories(currentCategories);
    }

    public setTargetCategories(targetCategories) {
        this.getTemplateViewModel().targetCategories(targetCategories);
    }

    public setRecategorizations(recategorizations) {
        this.getTemplateViewModel().recategorizations(recategorizations);
    }

    public setAffectedArticles(affectedArticles){
        this.getTemplateViewModel().affectedArticles(affectedArticles)
    }

    public setAffectedListingPages(affectedListingPages){
        this.getTemplateViewModel().affectedListingPages(affectedListingPages)
    }

    public setAffectedDeletedListingPage(affectedDeletedListingPage){
        this.getTemplateViewModel().affectedDeletedListingPage(affectedDeletedListingPage)
    }

    public setAffectedConflictedListingPage(affectedConflictedListingPage){
        this.getTemplateViewModel().affectedConflictedListingPage(affectedConflictedListingPage)
    }

    public isCurrentTagsLoading(loading){
        this.getTemplateViewModel().isCurrentTagsLoading(loading);
    }

    public isTargetTagsLoading(loading){
        this.getTemplateViewModel().isTargetTagsLoading(loading);
    }

    public isCurrentCategoriesLoading(loading){
        this.getTemplateViewModel().isCurrentCategoriesLoading(loading);
    }

    public isTargetCategoriesLoading(loading){
        this.getTemplateViewModel().isTargetCategoriesLoading(loading);
    }

    public isRecategorizationLoading(loading){
        this.getTemplateViewModel().isRecategorizationLoading(loading);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/recategorizationList_template.ts